import { ITimeLine, ITimeLineDevolution } from "models/Ticket/Timeline";

export interface IOrdersData {
  data: Array<IOrders>;
}

export enum IPaymentMethodType {
  CREDIT = 1,
  DEBIT = 2,
  BILLET = 3
}

export interface IKeyValue {
  key: string,
  value: string;
}

export const OrderStatusTypeDictionary: Array<IKeyValue> =
  [
    {
      key: "AWAITING_PROFITABILITY_RELEASE",
      value: "AGUARDANDO LIBERAÇÃO DE RENTABILIDADE"
    },
    {
      key: "AWAITING_CREDIT_RELEASE",
      value: "AGUARDANDO LIBERAÇÃO DE CRÉDITO"
    },
    {
      key: "SEPARATING",
      value: "EM SEPARAÇÃO"
    },
    {
      key: "OPENED",
      value: "ABERTO"
    },
    {
      key: "RELEASED",
      value: "LIBERADO"
    },
    {
      key: "BILLED",
      value: "FATURADO"
    },
    {
      key: "DONE",
      value: "FINALIZADO"
    }
  ];

export const TrackingStatusTypeDictionary: Array<IKeyValue> =
  [
    {
      key: "BUDGET_ENTRY",
      value: "Criação do pedido"
    },
    {
      key: "FINANCIAL_RELEASE",
      value: "Liberação do financeiro"
    },
    {
      key: "BILLING",
      value: "Faturamento"
    },
    {
      key: "IN_TRANSFER",
      value: "Em trânsito entre filiais"
    },
    {
      key: "ON_SCHEDULE",
      value: "Em agendamento"
    },
    {
      key: "AWAITING_DISPATCH",
      value: "Aguardando despacho"
    },
    {
      key: "ON_ROUTE",
      value: "Em rota de entrega"
    },
    {
      key: "ARRIVED",
      value: "Chegou no cliente"
    },
    {
      key: "DELIVERED",
      value: "Pedido entregue"
    },
    {
      key: "REFUSED",
      value: "Recusado pelo cliente"
    },
    {
      key: "DELIVERY_OCCURRENCE",
      value: "Ocorrência na Entrega"
    },
  ];

export enum ITrackingTypes {
  BUDGET_ENTRY = 1,
  FINANCIAL_RELEASE = 2,
  BILLING = 3,
  IN_TRANSFER = 4,
  ON_SCHEDULE = 5,
  AWAITING_DISPATCH = 6,
  ON_ROUTE = 7,
  ARRIVED = 8,
  DELIVERED = 9,
  REFUSED = 10,
  AWAITING_SCHEDULE = 11
}

export interface IOrders extends IMinimumOrderForDownload {
  customerId: string;
  invoiceNumber: string;
  invoiceSerialNumber: string;
  moneyOrderSale: string;
  protheusOrderSale: string;
  orderSale: string;
  paymentMethod: IPaymentMethodType;
  orderDate: Date | string;
  billingDate: Date | string;
  collectionDate: Date | string;
  expectedDeliveryDate: Date | string;
  invoiceDeliveryDate: string;
  situation: string;
  status: string;
  payment: string;
  totalOrderValue: number;
  timeLine: Array<ITimeLine>;
  devolutionTimeline: Array<ITimeLineDevolution>;
  items: Array<IOrderItem>;
  metadata: { [key: string]: string; };
  titleId: string;
  prefix: number;
  id: string;
  orderBU: string;
  subsidiary: string;
  subsidiaryId: string;
  subsidiaryName?: string;
  enterpriseCode?: number;
  enterpriseName?: string;
  shippingCompanyDocumentNumber: string;
  shippingCompanyName: string;
  devolutionInvoiceNumber: string;
  devolutionInvoiceSerialNumber: string;
  sellerIdentifier: string;
  sellerName?: string;
  sellerBuId?: string;
  sellerBuName?: string;
  invoiceShipping?: {
    customerIdentifier: string;
    customerName: string;
    documentNumber: string;
    invoiceNumber: string;
    invoiceSerialNumber: string;
    issueDate: string;
    orderNumber: string;
    totalOrderValue: string;
  };
  company?: {
    personType: string;
  };
  carbonEmission?: string;
  businessUnits?: string;
}

export interface IMinimumOrderForDownload {
  invoiceNumber: string;
  protheusOrderSale: string;
  subsidiary: string;
  enterpriseCode?: number;
}

export type TransactionInput = Pick<IOrders, "protheusOrderSale" | "id">;

export interface IOrderItem {
  number: number;
  code: string;
  name: string;
  unit: string;
  quantity: number;
  price: number;
  billingDate?: Date | string;
  promiseDate?: Date | string;
  cancelationDate?: Date | string;
  technicalReport?: string;
  dataSheet?: string;
  metadata?: { [key: string]: string; };
  productCode?: string;
  initialLot?: string;
  finalLot?: string;
  orderId?: string;
  returnQuantity: number;
  returnMultiplier: number;
  balance: number;
  itemNumber?: string;
  lots: Array<ILot>;
  shippingCompanyDocumentNumber?: string;
  shippingCompanyName?: string;
  correctionLetterKey?: string;
  locked: boolean;
  lot?: string;
}

export interface ILot {
  identifier: string;
  quantity: number;
  expirationDate: Date | string;
  manufacturingDate: Date | string;
}

export interface IOrderAttachments {
    isFromNewSource?: boolean,
    name: string,
    uri: string
}

export enum IDownloadTypes {
  BILLET = 1,
  INVOICE = 2,
  RECORD = 3,
  REPORT = 4,
  RECEIPT = 5,
  INVOICE_XML = 6,
  LETTERS = 7,
  DEVOLUTION_INVOICE = 8,
  DEVOLUTION_INVOICE_XML = 9,
  INVOICE_SHIPPING = 10,
  RECEIPT_SHIPPING = 11,
  INVOICE_SHIPPING_XML = 12,
  ELECTRONIC_BILL_LADING = 15,
  ELECTRONIC_BILL_LADING_XML = 16,
  INVOICE_BILL = 17
}

export enum ICompanies {
  EXPRESSA = 99
}

export enum InvoiceTypes {
  INVOICE = 0,
  INVOICE_DEVOLUTION = 1,
  INVOICE_SHIPPING = 2,
  ELECTRONIC_BILL_LADING = 3,
  INVOICE_BILL = 4
}

export enum OperationTypes {
  BONIFICACAO = "BONIFICACAO",
  DOACAO = "DOACAO",
  REMESSA_MERCADORIA_FALTANTE = "REMESSA DE MERCADORIA FALTANTE",
  REMESSA_CONSIGNACAO = "REMESSA EM CONSIGNACAO",
  VENDA_ORDEM = "VENDA A ORDEM",
  VENDA_CONSIGNACAO = "VENDA EM CONSIGNACAO",
  VENDAS = "VENDAS",
  LEGAL_DOCUMENT = "LEGAL_DOCUMENT",
  REGULATORY_DOCUMENT = "REGULATORY_DOCUMENT"
}

export enum OrdersTabsEnum {
  PEDIDO_FATURADO = "pedido_faturado",
  PEDIDO_PENDENTE = "pedido_pendente",
  VENDA_TRIANGULAR = "venda_triangular"
}

export const OrdersTabs: Array<string> = [
  "pedido_faturado",
  "pedido_pendente",
  "venda_triangular"
];

export enum EnumOrderItemStatusType {
  PENDENTE = 1,
  REALIZADO = 2,
}

export enum TicketReasonEnum {
  FOLLOWUP_EXTRACTION_NON_DELIVERY = "EXTRAÇÃO DE FOLLOW-UP NÃO ENTREGA",
  FOLLOWUP_EXTRACTION_DELIVERY = "EXTRAÇÃO DE FOLLOW-UP ENTREGA",
  TRIANGULAR_SALES_EXTRACTION = "EXTRAÇÃO DE VENDAS TRIANGULARES",
  EXTRACTION_ORDERS = "EXTRAÇÃO DE PEDIDOS"
}

export interface ITabLabel {
  label: TabLabelsEnum;
  trackingName: string;
}

export enum TabLabelsEnum {
  PEDIDOS_FATURADOS = "Pedidos Faturados",
  PEDIDOS_PENDENTES = "Pedidos Pendentes",
  VENDA_TRIANGULAR = "Venda Triangular" 
}
